import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';

import StayInTouchEmailSignUpContainer from 'containers/StayInTouchEmailSignUpContainer';

const StayInTouchController = class {
  static renderStayInTouchEmailSignUpForm = ({ store }) => {
    const domElement = document.getElementById('StayInTouch__form');

    if (domElement) {
      ReactDOM.render(
        <Provider store={store}>
          <StayInTouchEmailSignUpContainer />
        </Provider>,
        domElement
      );
    }
  };

  static init = store => {
    StayInTouchController.renderStayInTouchEmailSignUpForm({
      store,
    });
  };
};

export default StayInTouchController;
